import { useNavigate } from "react-router-dom";
import { useTheme, useMediaQuery, Box, Typography } from "@mui/material";
import { NAV_HEIGHT } from 'state/constants';


const menuItems = [
  { label: "Home", path: "/home" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
  // { label: "Sign In", path: "/auth/login" },
];

const PageHeader = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  const style = {
    cursor: "pointer",
    color: theme.palette.text.main,
    position: "relative",
    transition: "color 0.4s ease-in-out, transform 0.4s ease-in-out",
    "&:hover": {
      color: theme.palette.primary.main,
      transform: "scale(1.05)",
      backgroundColor: "transparent",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: -2,
      left: 0,
      width: "100%",
      height: "2px",
      background: `linear-gradient(
        90deg,
        ${theme.palette.primary.main},
        ${theme.palette.primary.light}
      )`,
      transform: "scaleX(0)",
      transformOrigin: "bottom left",
      transition: "transform 0.4s ease-in-out",
    },
    "&:hover::after": {
      transform: "scaleX(1)",
    },
  };


  return (
    <Box
      width="100%"
      height={NAV_HEIGHT}
      sx={{
        zIndex: 99,
        position: "sticky",
        top: 0,
        left: 0,
        padding: theme.spacing(1.5, 4),
        background: theme.palette.background.alt,
        display: "flex",
        justifyContent: isDesktop ? "flex-end" : "center",
        alignItems: "center",
        gap: theme.spacing(3),
      }}
    >
      {menuItems?.map((item) => (
        <Typography
          key={item.label}
          variant="button"
          onClick={() => navigate(item.path)}
          sx={style}
        >
          {item.label}
        </Typography>
      ))}
    </Box>
  );
};

export default PageHeader;